import _ from 'lodash'

const useSearch = (values, search) => {
  if (!values || !Array.isArray(values)) return []
  if (!search) return values

  const searchUpper = search.toUpperCase()

  return values.filter(member => {
    if (!member) return false

    const name = _.get(member, 'name', '')
    const label = _.get(member, 'label', '')

    return name.toUpperCase().includes(searchUpper) ||
      label.toUpperCase().includes(searchUpper)
  })
}

export default useSearch
